import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Set_WmsInnModelCheckbox } from "../SliceWmsInboundOutlet";
import { fKeyTabInput } from "../../../Utility/Utilitys";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
  CmpCheckboxField,
  CmpSelectArrField,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import { KernCAConfig } from "../../../Redux/roStore";
import { MultiCardFlag } from "../WmsInboundOutletAction";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  CmpSelectArrFieldV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCContent({
  fonChangeInputLDiscAmt,
  fGrossAmt,
  xStockObj,
  vRdxWmsHead, 
  xKey,
  xFocusInput,
  xBufferObj,
  sUnit,
  sFocFlagArr,
  sTypeArr,
  vRdxGRNtax1,
  vRdxGRNtax2,
  fUnit,
  fUnitRate,
  fLDiscPer,
  fFoc,
  fFocFlag,
  fExcise,
  fNetExcise,
  fTaxGroup,
  fCessGroup,
  fType,
  fUnitRateSave_onKeyUp,
  fNarration,
  fNetAmt,
  fDiscPer,
  fDiscAmt,
  fReduceCost,
  fItemName,
  fOpenContentItemSearchModalKey,
  fQty,
  fB_CI,
  xsIncentiveGroupsData,
  xSupervisorSlab,
  OtherSlabs,
  fOnChangeSelectSupervisorSlab,
  fOnChangeSelectIncGroup,
  fOnChangeSelectOtherSlab,
  fonChangeInputOtherAmtSc,
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
  xErrorMsgDetail,
  xContent_Focus,
  xContent_Blur,
  sPalletType,
  fPalletType,
  Reason,
  sReason,
  ReceivingPost = () => {},
}) { 
 
 
  // let IncentiveGroupShow = true;

  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state.SliceWmsInboundOutlet.value.Checkbox
  );
  const vModelCheckboxArr = [
    { name: "TDiscPercent", rdxName: vRdxCheckbox.TDiscPercent },
    { name: "TDiscAmt", rdxName: vRdxCheckbox.TDiscAmt },
    { name: "LDiscPercent", rdxName: vRdxCheckbox.LDiscPercent },
    { name: "LDiscAmt", rdxName: vRdxCheckbox.LDiscAmt },
    { name: "FOC", rdxName: vRdxCheckbox.FOC },
    { name: "Excise", rdxName: vRdxCheckbox.Excise },
    { name: "Tax", rdxName: vRdxCheckbox.Tax },

    { name: "Cess", rdxName: vRdxCheckbox.Cess },
    { name: "AddCess", rdxName: vRdxCheckbox.AddCess },
    { name: "UnitRate", rdxName: vRdxCheckbox.UnitRate },
    { name: "GrossAmt", rdxName: vRdxCheckbox.GrossAmt },
    { name: "NetValue", rdxName: vRdxCheckbox.NetValue },
    { name: "Total", rdxName: vRdxCheckbox.Total },
    { name: "RefNo", rdxName: vRdxCheckbox.RefNo },
    { name: "CardId", rdxName: vRdxCheckbox.CardId },
    { name: "PalletType", rdxName: vRdxCheckbox.PalletType },
    { name: "ItemCode", rdxName: vRdxCheckbox.ItemCode },
  ];
  const [sIsChecked, setIsChecked] = useState(false);
  const [sCheckBox, setCheckbox] = useState(vRdxCheckbox);
  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const fModalContentOpen = () => {
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };
  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setCheckbox((values) => ({ ...values, [nameValue]: iSCheck }));
  };
  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    const updatedObj = Object.keys(vRdxCheckbox).reduce((acc, key) => {
      acc[key] = iSCheck;
      return acc;
    }, {});

    setCheckbox(updatedObj);
  };
  useEffect(() => {
    dispatch(Set_WmsInnModelCheckbox(sCheckBox));
    const vIsAllTrue = Object.values(sCheckBox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [sCheckBox, dispatch]);
  return (
    <form className="Wms-inbound-grn-content" id="Content">
      <Grid
        container
        spacing={0.9}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
         
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid item xs={12} sm={6} md={6}>
            {xMediaQuery ? (
              <>
                <Grid
                  container
                  spacing={0}
                  columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                >
                  <Grid item xs={4} sm={6}>
                    <span
                      className={
                        vRdxWmsHead.A_DocStat !== "ENTER" ||
                        xBufferObj.B_Itmcd == ""
                          ? "hide-all-time"
                          : "d-flex justify-comtent-between"
                      }
                    >
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={"TransferQty=" + xStockObj.POQty}
                      />{" "}
                      &nbsp; &nbsp;
                    </span>
                  </Grid>
                  <Grid item xs={4} sm={6}>
                    <span
                      className={
                        vRdxWmsHead.A_DocStat !== "ENTER" ||
                        xBufferObj.B_Itmcd == ""
                          ? "hide-all-time"
                          : "d-flex justify-comtent-between"
                      }
                    >
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={" GRNQty=" + xStockObj.GRNQty}
                      />{" "}
                    </span>
                  </Grid>

                  <Grid item xs={4} sm={6}>
                    <span
                      className={
                        vRdxWmsHead.A_DocStat !== "ENTER" ||
                        xBufferObj.B_Itmcd == ""
                          ? "hide-all-time"
                          : "d-flex justify-comtent-between"
                      }
                    >
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={" BalanceQty=" + xStockObj.BalanceQty}
                      />{" "}
                      &nbsp; &nbsp;
                    </span>
                  </Grid>
                </Grid>
              </>
            ) : (
              <div className="d-flex justify-content-between">
                <span
                  className={
                    vRdxWmsHead.A_DocStat !== "ENTER" ||
                    xBufferObj.B_Itmcd == ""
                      ? "hide-all-time"
                      : "d-flex justify-comtent-between"
                  }
                >
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"TransferQty=" + xStockObj.POQty}
                  />{" "}
                  &nbsp; &nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={" GRNQty=" + xStockObj.GRNQty}
                  />{" "}
                  &nbsp; &nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={" BalanceQty=" + xStockObj.BalanceQty}
                  />{" "}
                  &nbsp; &nbsp;
                </span>
              </div>
            )}
          </Grid>
          <Grid item xs={9} sm={2} md={2}>
            {/* <CmpTypographyField
              xtextDecoration="underline"
              xcomponent={"div"}
              xText={" Rcvng.Post   " + " "}
              xonClick={ReceivingPost}
            /> */}
          </Grid>
          { !xMediaQuery &&   <Grid item xs={3} sm={3} md={3}>
            <MoreHorizOutlinedIcon
              onClick={fModalContentOpen}
              className="form-label gnr-title-txt"
            />
          </Grid>}
        </Grid>
        {/* {!xMediaQuery && (
          <Grid item xs={6} sm={2} md={1} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="S.No"
              xValue={xBufferObj.B_Srno}
              xType={"text"} // text/number/password
              xName={"B_Srno"}
              xReadOnly={true}
              xOnChange={""}
              xError={xErrorMsgDetail.B_Srno === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Srno}
              // xOnKeyUp={xKey}
            />
          </Grid>
        )} */}
        <Grid
          item
          xs={6}
          sm={2}
          md={1.5} 
          className={vRdxCheckbox?.RefNo ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="RefNo"
            xValue={xBufferObj.SuppRefNo1}
            xType={"text"} // text/number/password
            xName={"SuppRefNo1"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={6}
          sm={2}
          md={2} 
          // className={vRdxCheckbox?.Barcode ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Barcode"
            xValue={xBufferObj.B_Barcode}
            xType={"text"} // text/number/password
            xName={"Barcode"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        {vRdxCheckbox.ItemCode && (
          <Grid item xs={6} sm={2} md={2}  className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="Item Code"
              xValue={xBufferObj.B_Itmcd}
              xType={"text"} // text/number/password
              xName={"B_Itmcd"}
              xReadOnly={true}
              xOnChange={""}
              xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Itmcd}
              // xOnKeyUp={xKey}
            />
          </Grid>
        )}

        <Grid
          item
          xs={12}
          sm={6}
          md={xToggle ? 7.5 : 4}
          // md={"auto"}
          // lg={"auto"}
          className="lastkeyDetect"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={0.7} className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={"Qty"} /> */}
          <CmpTextFieldV1
            xLabelText="Qty"
            xtabIndex={"102"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_CI");
            }}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          lg={2.5}
          className={
            MultiCardFlag() || (vRdxCheckbox?.CardId && MultiCardFlag())
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="CardId"
            xtabIndex={"102.1"}
            xValue={xBufferObj.B_CI}
            xType={"text"} // text/number/password
            xName={"B_CI"}
            xReadOnly={false}
            xOnChange={fB_CI}
            xError={xErrorMsgDetail.B_CI === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_CI}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_URateFc");
            }}
            // xonFocus={xContent_Focus}
            // xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Unit"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
          />
        </Grid>
        <Grid item xs={6} sm={2} md={2} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="PackDesc"
            xValue={xBufferObj.PackDesc}
            xType={"text"} // text/number/password
            xName={"PackDesc"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1.5}
          className={
            vRdxCheckbox?.PalletType ? "lastkeyDetect" : "hide-content"
          }
        >
          <CmpSelectFieldV1
            xtabIndex={"103.1"}
            xLabelText="Pallet Type"
            xValue={xBufferObj.PalletType}
            xOnChange={fPalletType}
            xName={"PalletType"}
            xData={sPalletType}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.PalletType === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.PalletType}
            xDisable={false}
          />
        </Grid>
        {/* <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.SplDisc ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Spl.Disc"
            xValue={xBufferObj.SplDisc}
            xType={"text"} // text/number/password
            xName={"SplDisc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.SplDisc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.SplDisc}
            // xOnKeyUp={xKey}
          />
        </Grid> */}
        <Grid
          item
          xs={4}
          sm={2}
          md={0.7}
          className={vRdxCheckbox.UnitRate ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Unit Rate"
            xtabIndex={"104"}
            xValue={xBufferObj.B_URateFc}
            xType={"number"} // text/number/password
            xName={"B_URateFc"}
            xReadOnly={false}
            xOnChange={fUnitRate}
            xError={xErrorMsgDetail.B_URateFc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_URateFc}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            xOnKeyUp={(e) => fUnitRateSave_onKeyUp(e)}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.7}
          className={vRdxCheckbox.GrossAmt ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Gross Amt"
            xtabIndex={"105"}
            xValue={xBufferObj.B_GrossAmt}
            xType={"text"} // text/number/password
            xName={"B_GrossAmt"}
            xReadOnly={false}
            xOnChange={fGrossAmt}
            xError={xErrorMsgDetail.B_GrossAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_GrossAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.7}
          className={
            vRdxCheckbox.TDiscPercent ? "lastkeyDetect" : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="T.Disc %"
            xValue={xBufferObj.B_TDiscPerc}
            xType={"text"} // text/number/password
            xName={"B_TDiscPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TDiscPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TDiscPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.TDiscAmt ? "" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="T.Disc Amt"
            xValue={xBufferObj.B_TDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_TDiscAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TDiscAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TDiscAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.LDiscPercent ? "lastkeyDetect" : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="L.Disc %"
            xtabIndex={"106"}
            xValue={xBufferObj.B_LDiscPerc}
            xType={"number"} // text/number/password
            xName={"B_LDiscPerc"}
            xReadOnly={false}
            xOnChange={fLDiscPer}
            xError={xErrorMsgDetail.B_LDiscPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_LDiscPerc}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.LDiscAmt ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="L.Disc Amt"
            xValue={xBufferObj.B_LDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_LDiscAmt"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDiscAmt}
            xError={xErrorMsgDetail.B_LDiscAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_LDiscAmt}
            // xOnKeyUp={(e) => {
            //   xFocusInput("B_FocAmt");
            // }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          className={
            vRdxCheckbox.FOC ? "lastkeyDetect text-center " : "hide-content"
          }
          justifyContent={"center"}
        >
          <CmpCheckboxField
            xtabIndex={"107"}
            xChecked={xBufferObj?.B_FocFlag === "Y"}
            xOnChange={fFoc}
            xDisabled={false}
            xName={"B_FocFlag"}
            xNameField={"FOC"}
            xError={xErrorMsgDetail.B_FocFlag === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_FocFlag}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          className={vRdxCheckbox.FOC ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectArrFieldV1
            xtabIndex={"108"}
            xLabelText="FOC Flag"
            xValue={xBufferObj.B_AprmtFlag}
            xOnChange={fFocFlag}
            xName={"B_AprmtFlag"}
            xData={sFocFlagArr}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_AprmtFlag === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_AprmtFlag}
            xDisable={false}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.FOC ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="FOC Amount"
            xValue={xBufferObj.B_FocAmt}
            xType={"text"} // text/number/password
            xName={"B_FocAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_FocAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_FocAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Excise"
            xtabIndex={"109"}
            xValue={xBufferObj.B_ExciseTaxAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxAmt"}
            xReadOnly={false}
            xOnChange={fExcise}
            xError={xErrorMsgDetail.B_ExciseTaxAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ExciseTaxAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Net Excise"
            xtabIndex={"110"}
            xValue={xBufferObj.B_ExciseTaxNetAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxNetAmt"}
            xReadOnly={true}
            xOnChange={fNetExcise}
            xError={xErrorMsgDetail.B_ExciseTaxNetAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ExciseTaxNetAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.NetValue ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Net Value"
            xValue={xBufferObj.B_NetAmt}
            xType={"number"} // text/number/password
            xName={"B_NetAmt"}
            xReadOnly={xBufferObj.RebateType == "" ? true : false}
            xOnChange={fNetAmt}
            xError={xErrorMsgDetail.B_NetAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_NetAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Total ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Total"
            xtabIndex={"108"}
            xValue={xBufferObj.B_LandVal}
            xType={"number"} // text/number/password
            xName={"B_LandVal"}
            xReadOnly={true}

            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectFieldV1
            xtabIndex={"111"}
            xLabelText="Tax Group"
            xValue={xBufferObj.B_TaxDept}
            xOnChange={fTaxGroup}
            xName={"B_TaxDept"}
            xData={vRdxGRNtax1}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_TaxDept === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxDept}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Tax %"
            xValue={xBufferObj.B_TaxPerc}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Tax Amt"
            xValue={xBufferObj.B_TaxAmt}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxAmt}
            // xOnKeyUp={(e) => {
            //   xFocusInput("B_TaxPerc2");
            // }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectFieldV1
            xtabIndex={"112"}
            xLabelText="Cess Group"
            xValue={xBufferObj.B_TaxDept2}
            xOnChange={fCessGroup}
            xName={"B_TaxDept2"}
            xData={vRdxGRNtax2}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_TaxDept2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxDept2}
            xDisable={false}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Cess %"
            xValue={xBufferObj.B_TaxPerc2}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc2"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxPerc2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxPerc2}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Cess Amt"
            xValue={xBufferObj.B_TaxAmt2}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt2"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Add Cess"
            xValue={xBufferObj.AddCess}
            xType={"text"} // text/number/password
            xName={"AddCess"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Add Cess Amt"
            xValue={xBufferObj.B_NetAddCess}
            xType={"text"} // text/number/password
            xName={"B_NetAddCess"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_NetAddCess === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_NetAddCess}
            // xOnKeyUp={(e) => {
            //   xFocusInput("SplDiscPerc");
            // }}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1} lg={1.5}>
          <CmpSelectFieldV1
            xtabIndex={"103.1"}
            xLabelText="Reason"
            xValue={xBufferObj.Reason}
            xOnChange={Reason}
            xName={"Reason"}
            xData={sReason}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.Reason === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.Reason}
            xDisable={false}
          />
        </Grid>
          <Grid
                  item
                  xs={4}
                  sm={2}
                  md={0.5}
                  className="lastkeyDetect"
                  display={"flex  "}
                  alignItems={"center"}
                  justifyContent={"space-around"}
                >
                  
        
                  <div>
                    
                    {xMediaQuery && (
                       
                       <CmpButtonKWithIcon
                       xOnClick={(e) => { 
                        fModalContentOpen(e, "checkboxModal");
                      }}
                       xDisabled={false}
                       xIcon={<VisibilityIcon fontSize={"small"} />}
                       xcolor="primary"
                     />
                    )}
                  </div>
                </Grid>
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-content-checkbox">
          <GCTitleSticky title={"Detail list"} onClose={fModalContentClose} />

          <div className="container-fluid">
            <div className="wms-label">
              <div className="checkbox-mb">
                <label className="form-label ">
                  <input
                    className="form-check-input "
                    type="checkbox"
                    name="AllChecked"
                    checked={sIsChecked}
                    onChange={(e) => {
                      fIsAllChecked(e);
                    }}
                  />{" "}
                  All
                </label>
              </div>
              <>
                {vModelCheckboxArr?.map((obj, index) => (
                  <div className="checkbox-mb" key={"Wmscheckbox" + index}>
                    <label className="form-label">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        name={obj.name}
                        checked={obj.rdxName}
                        onChange={(e) => {
                          fSetCheckBox(e);
                        }}
                      />{" "}
                      {obj.name}
                    </label>
                  </div>
                ))}
              </>
            </div>
          </div>
        </Box>
      </Modal>
    </form>
  );
}
